import type { Camera, Object3D, Scene, SceneControl } from '@anov/3d-core'
import { OutlinePassExtend, OutputPass, Vector2, lib, use } from '@anov/3d-core'
import { EffectPass } from 'postprocessing'

type HighParamsType = {
  edgeStrength?: number // 边缘强度
  edgeGlow?: number // 缓缓接近
  edgeThickness?: number // 边缘厚度
  pulsePeriod?: number // 脉冲周期
  visibleEdgeColor?: string // 可见边缘颜色
  hiddenEdgeColor?: string // 隐藏边缘颜色
}

const { ShaderPass, GammaCorrectionShader } = lib
const { useScene } = use

const baseHighParams: HighParamsType = {
  edgeStrength: 10,
  edgeGlow: 1,
  edgeThickness: 3,
  visibleEdgeColor: '#FF5713',
  hiddenEdgeColor: '#FF5713',
}

/**
 *
 * @param highParams
 * @returns
 */
export const createHighSelectedTool = (highParams: HighParamsType | undefined, sceneControl: SceneControl) => {
  const lastHighParams = {
    ...baseHighParams,
    ...highParams,
  }

  const { scene, camera } = useScene(sceneControl)
  const composer = sceneControl.context.storeManagement.get('composer') as lib.EffectComposer | undefined

  if (!scene || !camera)
    throw new Error('scene or camera is not defined,')

  if (!composer) {
    console.error('composer is not defined, please initPostEffects first')
    return null
    // throw new Error('composer is not defined, please initPostEffects first')
  }

  const outlinePass = new OutlinePassExtend(new Vector2(window.innerWidth, window.innerHeight), scene, camera)

  outlinePass.edgeStrength = lastHighParams.edgeStrength
  outlinePass.edgeGlow = lastHighParams.edgeGlow
  outlinePass.edgeThickness = lastHighParams.edgeThickness
  lastHighParams.pulsePeriod && (outlinePass.pulsePeriod = lastHighParams.pulsePeriod)
  outlinePass.visibleEdgeColor.set(lastHighParams.visibleEdgeColor)

  composer.addPass(outlinePass)
  composer.addPass(new OutputPass())

  const gammaCorrectionShader = new ShaderPass(GammaCorrectionShader)

  // if (!storeManagement.get<boolean>('__&&__gammaCorrectionShader')) {
  //   composer.addPass(gammaCorrectionShader)
  //   storeManagement.set('__&&__gammaCorrectionShader', true)
  // }

  return (object3dArray: Object3D[]) => {
    outlinePass.selectedObjects = object3dArray
  }
}

export class OutlinePass extends EffectPass {
  private outlinePass: OutlinePassExtend

  constructor(scene: Scene, camera: Camera) {
    super()

    this.outlinePass = new OutlinePassExtend(new Vector2(window.innerWidth, window.innerHeight), scene, camera)

    this.outlinePass.edgeStrength = baseHighParams.edgeStrength
    this.outlinePass.edgeGlow = baseHighParams.edgeGlow
    this.outlinePass.edgeThickness = baseHighParams.edgeThickness
    this.outlinePass.visibleEdgeColor.set(baseHighParams.visibleEdgeColor)
    this.outlinePass.hiddenEdgeColor.set(baseHighParams.hiddenEdgeColor)
  }

  public selectedObjects(object3dArray: Object3D[]) {
    this.outlinePass.selectedObjects = object3dArray
  }
}
